import { RefObject, useMemo } from 'react';
import { IRegionFAQ } from '@/api/region/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { FaqList } from '@/components/region/FaqList';
import { Heading } from '@/components/ui/heading';
import { SanitizeMode, useSanitizedHtmlProps } from '@/util/sanitized';

import { IHTMLParsedData, parseHTMLtoList } from '@/util/parseHTMLtoList';

export const RegionFAQ = ({
  regionTitle,
  regionFAQ,
  refScroll,
  placeholders,
}: {
  regionTitle: string,
  regionFAQ: IRegionFAQ,
  refScroll?: RefObject<HTMLDivElement>,
  placeholders?: Record<string, string>,
}) => {
  const { t } = useOTSTranslation('common');

  if (!regionFAQ.descriptionRegion) {
    return null;
  }

  const { list, text } = useMemo<IHTMLParsedData>(
    () => parseHTMLtoList(regionFAQ.descriptionRegion, placeholders || {}),
    [regionFAQ],
  );

  const htmlProps = useSanitizedHtmlProps(text || '', SanitizeMode.NormalWithImages);

  return (
    <section ref={refScroll}>
      <Heading
        level={2}
        className="mb-4"
      >
        {t('region.resortGuide.FaqTitle', { region: regionTitle })}
      </Heading>
      {text && (
        <div
          {...htmlProps}
          className="mb-4 text-sm leading-relaxed text-muted-foreground"
        />
      )}
      <FaqList items={list} defaultOpenFirst />
    </section>
  );
};
